import React, { FC } from "react"

interface confirmationModalState {
  display: boolean,
  type: string,
  confirmationMemberData: membersModel[] | null
  callback: () => void
}

interface membersModel {
  id: number
  name: string | null
  kana: string | null
  code: string | null
  contract: string | null
  change_authority: boolean
  profile_image: string | null
}

interface props {
  confirmationModalState: confirmationModalState
  closeCallback: VoidFunction
}

const ConfirmationModal: FC<props> = (props) => {
  const {
    confirmationModalState,
    closeCallback,
  } = props

  const submit = () => {
    confirmationModalState.callback()
    closeCallback()
  }

  return (
    <>
      {
        confirmationModalState.display && (
          <div className="edit_modal_wrap">
            <div className={`edit_modal ${confirmationModalState.display || 'none'}`}>
              <div className="edit_modal_header">
                { confirmationModalState.type === "destroy" ? "個別設定の削除" : "編集権限変更"}
                <button type="button" className="close_modal" onClick={closeCallback}>
                  &times;
                </button>
              </div>
              <div className="edit_modal_body">
                <p>
                  メンバー名 :
                  &nbsp;
                  <span>{confirmationModalState.confirmationMemberData?.map(((v) => v.name))}</span>
                </p>
                <p>
                  対象メンバーの
                  {confirmationModalState.type === "destroy" ? "個別設定を削除" : "編集権限を変更"}
                  します
                </p>
                {
                  confirmationModalState.type === "destroy" ? <p>個別設定を削除後は、会社の基本設定が適用されます</p> : ""
                }
              </div>
              <div className="edit_modal_footer">
                <button
                  type="button"
                  onClick={closeCallback}
                  className="button cancel"
                >
                  キャンセル
                </button>
                <button
                  type="button"
                  onClick={() => submit()}
                  className={`button ${confirmationModalState.type === "destroy" ? "delete" : ""}`}
                >
                  {
                    confirmationModalState.type === "destroy" ? "削除" : "確認"
                  }
                </button>
              </div>
            </div>
            <div
              className="gray_area"
              onClick={closeCallback}
              role="none"
            />
          </div>
        )
      }
    </>
  )
}

export default ConfirmationModal
